<template>
  <sui-label class="status" :class="{extended}" :icon="status.icon" :color="status.color" size="small">
    <span class="status-text">
      {{status.text}}
      <span class="process-timer" v-if="this.entity.process">
        <i class="clock icon" />
        <Timer :started="this.entity.processStarted" :active="!this.entity.lastResult" />
      </span>
    </span>
    <div class="container-statuses" v-if="extended">
      <span class="container-status" :class="{active: containerStatuses[0]}" title="Online containers">{{containerStatuses[0]}}</span>
      <span class="container-status" :class="{active: containerStatuses[1]}" title="Restarting containers">{{containerStatuses[1]}}</span>
      <span class="container-status" :class="{active: containerStatuses[2]}" title="Offline containers">{{containerStatuses[2]}}</span>
    </div>
  </sui-label>
</template>

<script>
  import groupBy from 'lodash/groupBy'

  export default {
    name: 'EntityStatus',
    props: {
      entity: {
        type: Object,
        required: true,
      },
      extended: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    computed: {
      containerStatuses() {
        const statuses = {ONLINE: [], RESTARTING: [],  OFFLINE: [],...groupBy(this.entity._containers, 'status')}
        return [statuses.ONLINE.length, statuses.RESTARTING.length, statuses.OFFLINE.length]
      },
      status() {
        return this.entity._status
      },
    }
  }
</script>

<style scoped>
  .status { display: flex!important; margin: 0!important; }
  .status.extended { align-items: center; }
  .status-text { display: flex; flex: 1; }
  .process-timer { display: flex; margin-left: 1em; opacity: .6; }
  .container-statuses { margin: -.3em 0 -.2em 1em; }
  .container-status { margin-left: .2em; padding: .2em .5em; border-radius: .2em; border: 1px solid #3333; display: none; }
  .container-status.active { display: inline; }
  .container-status:nth-child(1) { background-color: rgba(0, 255, 0, .4); }
  .container-status:nth-child(2) { background-color: rgba(255, 150, 0, .4); }
  .container-status:nth-child(3) { background-color: rgba(255, 0, 0, .4); }
</style>
